var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKeypad = function SvgKeypad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "keypad_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".keypad_svg__st0{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 3.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 3.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 9.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 9.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 15.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 15.5,
    r: 2,
    className: "keypad_svg__st0"
  })));
};
export { SvgKeypad as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiAKCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgCgl4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KCTxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9Cgk8L3N0eWxlPgoJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iNC41IiBjeT0iMy41IiByPSIyIi8+Cgk8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIxMiIgY3k9IjMuNSIgcj0iMiIvPgoJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMTkuNSIgY3k9IjMuNSIgcj0iMiIvPgoJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iNC41IiBjeT0iOS41IiByPSIyIi8+Cgk8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIxMiIgY3k9IjkuNSIgcj0iMiIvPgoJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMTkuNSIgY3k9IjkuNSIgcj0iMiIvPgoJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iNC41IiBjeT0iMTUuNSIgcj0iMiIvPgoJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMTIiIGN5PSIxNS41IiByPSIyIi8+Cgk8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIxMiIgY3k9IjIxLjUiIHI9IjIiLz4KCTxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjE5LjUiIGN5PSIxNS41IiByPSIyIi8+Cjwvc3ZnPgo=";